import React from 'react';
import { HeartIcon, MessageCircleIcon, SendIcon, BookmarkIcon, MoreHorizontalIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  return <section id="testimonials" className="w-full py-12 bg-amber-50" data-id="element-309">
      <div className="container mx-auto px-4" data-id="element-310">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-4 text-center" data-id="element-311">
          Loved by Pet Parents... and Over 4 Million Dogs Worldwide!
        </h2>
        <p className="text-green-900/80 mb-8 text-center max-w-3xl mx-auto" data-id="element-312">
          Real Success Stories From Verified Customers:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-313">
          {/* Instagram Post 1 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-314">
            <div className="flex items-center justify-between p-3 border-b border-gray-200" data-id="element-315">
              <div className="flex items-center gap-2" data-id="element-316">
                <img src="https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Margaret S." className="w-8 h-8 rounded-full object-cover" data-id="element-317" />
                <div data-id="element-318">
                  <p className="text-sm font-semibold" data-id="element-319">margaret_and_rosie</p>
                  <p className="text-xs text-gray-500" data-id="element-320">Boulder, Colorado</p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-321">
                <MoreHorizontalIcon size={20} className="text-gray-700" data-id="element-322" />
              </div>
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Instagram_logo_2016.svg/132px-Instagram_logo_2016.svg.png" alt="Instagram logo" className="absolute top-3 right-3 w-5 h-5 opacity-50" data-id="element-323" />
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ofzx98bgbqV2PwZAq6TrDr/topview_image_68d9dcb18c9d4daba553d7fe95210fa7.png" alt="Rosie the terrier with a jar of Snouty & Co. Daily Foundation Chew on grass" className="w-full aspect-square object-cover" data-id="element-324" />
            <div className="p-3" data-id="element-325">
              <div className="flex justify-between mb-2" data-id="element-326">
                <div className="flex gap-4" data-id="element-327">
                  <HeartIcon size={24} className="text-red-500 fill-red-500" data-id="element-328" />
                  <MessageCircleIcon size={24} className="text-gray-700" data-id="element-329" />
                  <SendIcon size={24} className="text-gray-700" data-id="element-330" />
                </div>
                <BookmarkIcon size={24} className="text-gray-700" data-id="element-331" />
              </div>
              <p className="font-semibold text-sm mb-1" data-id="element-332">3,482 likes</p>
              <p className="text-sm mb-1" data-id="element-333">
                <span className="font-semibold" data-id="element-334">margaret_and_rosie</span> I
                bought @DailyFoundationChew for Rosie's terrible gas and
                irregular stools. Not only did those issues resolve within DAYS,
                but she's also moving better, her coat is gorgeous, and she has
                energy I haven't seen in years. It's like I got my young dog
                back! 🐶❤️
              </p>
              <p className="text-sm text-blue-900 mb-1" data-id="element-335">
                #DailyFoundationChew #DogsOfInstagram #PetHealth #SeniorDog
                #DogMom #GutHealth #HappyDog
              </p>
              <p className="text-gray-500 text-xs mb-1" data-id="element-336">
                View all 241 comments
              </p>
              <p className="text-sm mb-1" data-id="element-337">
                <span className="font-semibold" data-id="element-338">dog_lover_23</span> Wow! She
                looks amazing! I need to try this for my pup!
              </p>
              <p className="text-gray-400 text-xs uppercase" data-id="element-339">2 days ago</p>
            </div>
          </div>
          {/* Instagram Post 2 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-340">
            <div className="flex items-center justify-between p-3 border-b border-gray-200" data-id="element-341">
              <div className="flex items-center gap-2" data-id="element-342">
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="James T." className="w-8 h-8 rounded-full object-cover" data-id="element-343" />
                <div data-id="element-344">
                  <p className="text-sm font-semibold" data-id="element-345">james_and_duke</p>
                  <p className="text-xs text-gray-500" data-id="element-346">Portland, Oregon</p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-347">
                <MoreHorizontalIcon size={20} className="text-gray-700" data-id="element-348" />
              </div>
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Instagram_logo_2016.svg/132px-Instagram_logo_2016.svg.png" alt="Instagram logo" className="absolute top-3 right-3 w-5 h-5 opacity-50" data-id="element-349" />
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fU4j8gNB5aVLFT4xYcEUBY/topview_image_fb03a32b639048b7a91889bcf712f4b4.png" alt="Corgi on green grass with a jar of Snouty & Co. Daily Foundation Chew" className="w-full aspect-square object-cover" data-id="element-350" />
            <div className="p-3" data-id="element-351">
              <div className="flex justify-between mb-2" data-id="element-352">
                <div className="flex gap-4" data-id="element-353">
                  <HeartIcon size={24} className="text-red-500 fill-red-500" data-id="element-354" />
                  <MessageCircleIcon size={24} className="text-gray-700" data-id="element-355" />
                  <SendIcon size={24} className="text-gray-700" data-id="element-356" />
                </div>
                <BookmarkIcon size={24} className="text-gray-700" data-id="element-357" />
              </div>
              <p className="font-semibold text-sm mb-1" data-id="element-358">5,129 likes</p>
              <p className="text-sm mb-1" data-id="element-359">
                <span className="font-semibold" data-id="element-360">james_and_duke</span> Duke
                refused every supplement we tried. He actually gets excited for
                his @DailyFoundationChew! His allergies have calmed down, his
                digestion is perfect, and no more 3am stomach gurgles. Worth
                every penny. 🙌 #TransformationTuesday
              </p>
              <p className="text-sm text-blue-900 mb-1" data-id="element-361">
                #DailyFoundationChew #DogsOfInstagram #PickyEater #DogDad
                #ProbioticForDogs #GutHealth #HappyPup
              </p>
              <p className="text-gray-500 text-xs mb-1" data-id="element-362">
                View all 387 comments
              </p>
              <p className="text-sm mb-1" data-id="element-363">
                <span className="font-semibold" data-id="element-364">healthy_paws</span> Amazing
                results! My dog had the same issue!
              </p>
              <p className="text-gray-400 text-xs uppercase" data-id="element-365">5 days ago</p>
            </div>
          </div>
          {/* Instagram Post 3 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-366">
            <div className="flex items-center justify-between p-3 border-b border-gray-200" data-id="element-367">
              <div className="flex items-center gap-2" data-id="element-368">
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Sarah M." className="w-8 h-8 rounded-full object-cover" data-id="element-369" />
                <div data-id="element-370">
                  <p className="text-sm font-semibold" data-id="element-371">sarah_and_bella</p>
                  <p className="text-xs text-gray-500" data-id="element-372">Austin, Texas</p>
                </div>
              </div>
              <div className="flex items-center" data-id="element-373">
                <MoreHorizontalIcon size={20} className="text-gray-700" data-id="element-374" />
              </div>
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Instagram_logo_2016.svg/132px-Instagram_logo_2016.svg.png" alt="Instagram logo" className="absolute top-3 right-3 w-5 h-5 opacity-50" data-id="element-375" />
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bS8gLJ3xMzKxa9Z2vQ2FCc/Frame_185_1.webp" alt="Before and after photos showing Bella's dramatic skin improvement with Daily Foundation Chew" className="w-full aspect-square object-cover" data-id="element-376" />
            <div className="p-3" data-id="element-377">
              <div className="flex justify-between mb-2" data-id="element-378">
                <div className="flex gap-4" data-id="element-379">
                  <HeartIcon size={24} className="text-red-500 fill-red-500" data-id="element-380" />
                  <MessageCircleIcon size={24} className="text-gray-700" data-id="element-381" />
                  <SendIcon size={24} className="text-gray-700" data-id="element-382" />
                </div>
                <BookmarkIcon size={24} className="text-gray-700" data-id="element-383" />
              </div>
              <p className="font-semibold text-sm mb-1" data-id="element-384">4,768 likes</p>
              <p className="text-sm mb-1" data-id="element-385">
                <span className="font-semibold" data-id="element-386">sarah_and_bella</span> Bella had
                chronic ear infections, itchy skin, and was always lethargic.
                After 2 months on @DailyFoundationChew, my vet asked what I'd
                changed. She couldn't believe it was just a supplement. No more
                infections, beautiful coat, tons of energy! 🐾
              </p>
              <p className="text-sm text-blue-900 mb-1" data-id="element-387">
                #DailyFoundationChew #DogsOfInstagram #VetApproved #PetHealth
                #EarInfections #GutHealth #BeforeAndAfter
              </p>
              <p className="text-gray-500 text-xs mb-1" data-id="element-388">
                View all 319 comments
              </p>
              <p className="text-sm mb-1" data-id="element-389">
                <span className="font-semibold" data-id="element-390">vet_dr_jones</span> This is
                amazing! Gut health is so important!
              </p>
              <p className="text-gray-400 text-xs uppercase" data-id="element-391">1 week ago</p>
            </div>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-392">
          <a href="#dosage" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-393">
            LEARN MORE
          </a>
        </div>
      </div>
    </section>;
};